<template>
  <StaffLayout section="Video Library" showHeader>
    <Loading v-if="isLoading" />
    <div v-else>
      <div v-if="videos && videos.length > 0">
        <AddButton @click="addClick">Add Video</AddButton>
        <router-link
          class="text-lg block pt-1 pb-2 px-3 my-2 bg-gray-100 border-t hover:bg-teal-100 cursor-pointer"
          v-for="video in videos"
          :key="video.videoId"
          :to="`video/${video.videoId}`"
        >
          <p v-if="video.fileName">{{ video.fileName }}</p>
          <p v-else class="text-gray-500">No filename</p>
          <p class="text-sm pl-4">{{ video.label }}</p>
        </router-link>
      </div>
      <div v-else class="mb-2">
        <span>-- No Videos found --</span>
      </div>
      <div>
        <AddButton @click="addClick">Add Video</AddButton>
      </div>
    </div>
    <EditPopup
      entity-name="Video"
      :is-visible="isPopupVisible"
      :is-edit-mode="false"
      :save-error="saveError"
      @close="isPopupVisible = false"
      @save="startSave"
    >
      <BaseInput
        label="File Name"
        v-model="fileName"
        type="text"
        :error="errors.fileName"
      />
      <BaseInput label="Label" v-model="label" type="text" :error="errors.label" />
      <BaseInput
        label="Stream Path"
        v-model="streamPath"
        type="text"
        :error="errors.streamPath"
      />
      <div class="mt-3" />
      <BaseCheckbox label="Is Full Video" v-model="isFullVideo" />
      <div class="mt-5 border-b mb-4" />
      <BaseInput
        label="English Captions URL"
        v-model="captionsUrlEn"
        type="text"
        :error="errors.captionsUrlEn"
      />
      <BaseInput
        label="Spanish Captions URL"
        v-model="captionsUrlEs"
        type="text"
        :error="errors.captionsUrlEs"
      />
    </EditPopup>
  </StaffLayout>
</template>

<script setup lang="ts">
import { useAdminStore } from "../../store/adminStore";
import { SaveVideoRequest } from "../../store/generatedFetchClient";

import { useField, useForm } from "vee-validate";
import * as yup from "yup";

const adminStore = useAdminStore();
let isLoading = ref(true);
let isPopupVisible = ref(false);

onMounted(loadData);
async function loadData() {
  isLoading.value = true;
  await adminStore.getVideosList();
  isLoading.value = false;
}

let videos = computed(() => adminStore.videos);

// Popup stuff
let saveError = ref("");

const { handleSubmit, errors } = useForm({
  validationSchema: yup.object({
    fileName: yup.string().required().max(512).label("File Name"),
    label: yup.string().required().max(50).label("Label"),
    streamPath: yup.string().required().max(512).label("Stream Path"),
    captionsUrlEn: yup.string().notRequired().max(512).label("English Captions URL"),
    captionsUrlEs: yup.string().notRequired().max(512).label("Spanish Captions URL"),
  }),
  initialValues: {
    fileName: "",
    label: "",
    streamPath: "",
    captionsUrlEn: "",
    captionsUrlEs: "",
  },
});

const { value: fileName } = useField<string>("fileName");
const { value: label } = useField<string>("label");
const { value: streamPath } = useField<string>("streamPath");
let isFullVideo = ref(true);
const { value: captionsUrlEn } = useField<string>("captionsUrlEn");
const { value: captionsUrlEs } = useField<string>("captionsUrlEs");

let startSave = handleSubmit(onValidSubmit, onInvalidSubmit);

async function onValidSubmit() {
  saveError.value = "";

  let v = {
    fileName: fileName.value,
    label: label.value,
    streamPath: streamPath.value,
    isFullVideo: isFullVideo.value,
    captionsUrlEn: captionsUrlEn.value,
    captionsUrlEs: captionsUrlEs.value,
  } as SaveVideoRequest;

  saveError.value = await adminStore.saveVideo(v);
  if (saveError.value) return;

  isPopupVisible.value = false;
  isLoading.value = true;
  await adminStore.getVideosList(true);
  isLoading.value = false;
}

function onInvalidSubmit(ctx: any) {
  saveError.value = "One or more invalid form inputs.";
}

function addClick() {
  fileName.value = "";
  label.value = "";
  streamPath.value = "";
  isFullVideo.value = true;
  captionsUrlEn.value = "";
  captionsUrlEs.value = "";

  saveError.value = "";
  isPopupVisible.value = true;
}
</script>
